module.exports = __webpack_public_path__ + "images/apple-touch-icon-60x60-d544fa2cb5faa012e7e6a130826dc3bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicons/apple-touch-icon-60x60.png
// module id = ./src/images/favicons/apple-touch-icon-60x60.png
// module chunks = 1